// extracted by mini-css-extract-plugin
module.exports = {"Selector":"LangSelector_Selector__2Tq-_"};